import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../PlantDesignDetails.module.scss';
import { FormGroup, Input } from '@snsw/react-component-library';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import { PlantDesignDetailsPage } from 'plantDesign/constants/plantDesignDetailsPage';

export const MobileCraneDesignDetails = React.forwardRef((props, ref) => {
  const { maxRatedCapacity: savedMaxRatedCapacity = '', maxRadius: savedMaxRadius = '' } = props.value || {};

  const [maxRatedCapacity, setMaxRatedCapacity] = useState(savedMaxRatedCapacity);
  const [maxRadius, setMaxRadius] = useState(savedMaxRadius);

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);

  const PAGE_CONSTANTS = PlantDesignDetailsPage.mobileCrane;

  const validators = [
    {
      fieldName: 'maxRatedCapacity',
      fieldValue: maxRatedCapacity,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxRadius',
      fieldValue: maxRadius,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  if (ref) {
    ref.current = {
      validate: () => {
        const isCurrentComponentValid = validateExt(validators, setErrors, setErrorSummary);
        setShowErrors(!isCurrentComponentValid);
        return isCurrentComponentValid;
      },
    };
  }

  useEffect(() => {
    const details = {
      maxRatedCapacity,
      maxRadius,
    };
    props.onChange(details);

    if (showErrors) validateExt(validators, setErrors, setErrorSummary);
  }, [maxRatedCapacity, maxRadius]);

  useEffect(() => {
    props.onErrorChange(errorSummary);
  }, [errorSummary]);

  return (
    <>
      <FormGroup
        id="maxRatedCapacity"
        label={PAGE_CONSTANTS.maxRatedCapacity.label}
        isRequired
        errorMessage={errors?.maxRatedCapacity?.errorMessage}
        hasError={showErrors && errors?.maxRatedCapacity?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxRatedCapacity.suffix}
          onChange={(e) => setMaxRatedCapacity(e.target.value)}
          value={maxRatedCapacity}
          inputWidth="md"
        />
      </FormGroup>

      <FormGroup
        id="maxRadius"
        label={PAGE_CONSTANTS.maxRadius.label}
        isRequired
        errorMessage={errors?.maxRadius?.errorMessage}
        hasError={showErrors && errors?.maxRadius?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxRadius.suffix}
          onChange={(e) => setMaxRadius(e.target.value)}
          value={maxRadius}
          inputWidth="md"
        />
      </FormGroup>
    </>
  );
});

MobileCraneDesignDetails.displayName = 'MobileCraneDesignDetails';

MobileCraneDesignDetails.propTypes = {
  value: PropTypes.object,
  refData: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onErrorChange: PropTypes.func.isRequired,
};
